<template>
  <div class="lcl-consol-main">
    <div class="lcl-consol" >
      <div class="lcl-consol_cards">
        <div class="lcl-consol_cards-title">
          <p>
            Các công ty Freight Forwarder lựa chọn chúng tôi vì WE ARE ONE là
            nhà liên minh GOM HÀNG hàng đầu.
          </p>
          <p>
            Khi sử dụng dịch vụ của WR1, bạn sẽ được ổn định được dịch vụ hằng
            tuần với các tuyến Direct từ HCM/ HPH đến các port: - INTRA ASIA :
            Hong Kong, Shanghai, Thailand (Bangkok, Leam Chabang), Taiwan
            (Kaohsiung, Taichung), Singapore, Port Klang, Jakarta, Korea (Busan,
            Incheon), Japan (Osaka, Kobe, Tokyo, Yokohama, Nagoya)
          </p>
          <p>- Europe main ports (Southampton, Valencia, Rotterdam)</p>
          <div class="lcl-consol_cards-title-meta">
            <img
              class="lcl-consol_cards-title-meta-photo"
              v-lazy="
                require(`@/assets/images/core-service/lcl-consol-1.png`)
              "
              alt=""
            />
          </div>
        </div>
      </div>
    </div>

    <div class="lcl-consol-text">
      <div class="lcl-consol-text-blog-card">
        <div class="lcl-consol-text-blog-card-text">
          <div>
            <p class="lcl-consol-text-blog-card-text-description">
              Các công ty Freight Forwarder lựa chọn chúng tôi vì WE ARE ONE là
              nhà liên minh GOM HÀNG hàng đầu.
            </p>
            <p class="lcl-consol-text-blog-card-text-description">
              Khi sử dụng dịch vụ của WR1, bạn sẽ được:
              <ul>
                <li>
                Được update nhanh chóng, kịp thời về lịch trình, tình trạng 
                </li>
                  <li>
               Lấy giá và booking nhanh chóng qua hệ thống inquiry & booking online của cty. 
                </li>
                  <li>
               Liên minh mạnh, sản lượng tốt sẽ có được giá tốt từ hãng tàu
                </li>
                  <li>
               Mạng lưới HUB CFS và Hệ thống Agent toàn cầu đảm bảo kết nối tối ưu, phục vụ và xử lý nhanh chóng
                </li>
                  <li>
               Là một giải pháp để tư vấn cho khách hàng của bạn. Gom hàng giúp giảm chi phí và thời gian vận chuyển hàng hóa, loại bỏ nhu cầu xếp dỡ hàng hóa nhiều lần.
                </li>
                  <li>
               Tận dụng tối đa năng suất khi cung cấp được nhiều dịch vụ cùng lúc: OF LCL, CUSTOMS, TRUCKING
                </li>
                  <li>                
              Ổn định được dịch vụ hằng tuần với các tuyến Direct từ HCM/ HPH đến các port:
                </li>
                  <li>
                Được update nhanh chóng, kịp thời về lịch trình, tình trạng 
                </li>
                  <li>
                Được update nhanh chóng, kịp thời về lịch trình, tình trạng 
                </li>
                  <li>
                Được update nhanh chóng, kịp thời về lịch trình, tình trạng 
                </li>

                </ul>
            </p>

            <div class="lcl-consol-text-blog-card-text-description"><p>- INTRA ASIA : Hong Kong, Shanghai, Thailand (Bangkok, Leam Chabang), Taiwan (Kaohsiung, Taichung), Singapore, Port Klang, Jakarta, Korea (Busan, Incheon), Japan (Osaka, Kobe, Tokyo, Yokohama, Nagoya) 
</p>- Europe main ports (Southampton, Valencia, Rotterdam)</div>
         
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>
<style lang="scss" scoped>
.lcl-consol-main {
  position: relative;

  @media (min-width: 1024px) {
    &:nth-child(1) {
      &::after {
        content: "";
        position: absolute;
        top: 15%;
        transform: translate(0, -50%);
        right: -80px;
        background-image: url("../../../../../assets/images/core-service/core-top.png");
        background-size: 300px 300px;
        display: inline-block;
        width: 300px;
        height: 300px;
      }
      &::before {
        content: "";
        position: absolute;
        bottom: 800px;
        left: -120px;
        background-image: url("../../../../../assets/images/core-service/core-bottom.png");
        background-size: 300px 300px;
        display: inline-block;
        width: 300px;
        height: 300px;
      }
    }
  }

  .lcl-consol {
    @media (min-width: 900px) {
      padding: 70px 70px;
    }
    @media (min-width: 1024px) {
      padding: 70px 230px;
    }
    @media (min-width: 1900px) {
      padding: 100px 470px;
    }
    &_cards {
      padding: 40px;

      @media (min-width: 900px) {
        padding-left: 0;
      }
      &-title {
        color: var(--text-normal-color);
        font-style: var(--normal-font-size);
        font-weight: 400;
        &-meta {
          &-photo {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }
      }
    }
  }

  .lcl-consol-text {
    @media (min-width: 900px) {
      padding: 40px 70px 70px;
    }
    @media (min-width: 1024px) {
      padding: 40px 70px 230px;
    }
    @media (min-width: 1900px) {
      padding: 100px 470px;
    }
    background-color: var(--bg-color-2);

    &-blog-card {
      &-text {
        padding: 30px;
        display: flex;
        flex-direction: column;
        gap: 30px;

        &-description {
          color: var(--text-normal-color);
          font-style: var(--normal-font-size);
          font-weight: 400;
          ul {
            li {
              list-style: none !important;
              &::before {
                content: "\2022";
                color: #2b938c;
                font-weight: bold;
                display: inline-block;
                font-size: 20px;
                width: 1em;
                margin-left: -1.5em;
                margin-right: -10px;
              }
            }
          }
        }
      }
    }
  }
}
</style>